import styled from '@emotion/styled/macro';
import { Box } from 'rebass';

export const RelativeBox = styled(Box)`
  position: relative;
`;
